<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/ic_banner.png');">
          <div class="banner_item1_content">
            <p>物联网管控系统</p>
            <p class="txt1">
              在3分钟内赶到现场，快速处置或控制火灾蔓延，并组织人员疏散
            </p>
            <div class="item1_infoBox ic_btnColor">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">方案简介</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">利用物联网技术、建立视频监控、无限独立式（烟雾报警器、燃气探测器、电气火灾探测器、水压探测器等）物联传感设备、手动报警设置、广播系统，通过NB-IOT、lora、4g、wifi等通信手段实时探测传感设备的运行及报警情况，并借助于移动互联网技术将报警消息（真实警情、未及时处理、误报）推送给各级责任人，并记录处置过程，形成警情处置闭环</span>
        </div>
        <div class="part6_content_img">
          <img src="static/image/ic_part1_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part1Box part1_space">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">解决方案</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">主要实现责任范围管理、安全生产管理、隐患综合治理、一张图预警和综合管理等功能。其中安全生产管理又包括目标管理、管理架构、专项工作落实、安全生产责任制、领导责任落实、安全检查、宣传培训、设备管理、安全生产投入、职业卫生健康等功能。隐患综合治理包括隐患台账、隐患随手拍、整改派单、现场整改、整改审核和闭环存档。</span>
        </div>
        <div class="part6_content_img">
          <img src="static/image/ic_part1_bg2.png" alt="">
        </div>
      </div>
    </div>
    <div class="part2Box" style="background-image: url('static/image/ic_part2_bg1.png')">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1 part2_txt1">方案简介</span>
          <span class="part1_header_txt2 part2_txt2">全面推开将为科学高效监管提供新思路</span>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">推荐产品</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">智慧视频监控系统</p>
          <p class="part3_item_txt2">通过给消防重点的区域布置摄像机，通过视频可以进行事前的可视化检查管理、事故发生时的视频录像保存、事故发生时的实时视频的画面协助紧急的调度和救援。消防监控管理中心收到消防报警信息后，根据监控系统摄像头与报警位置的对应关系，在软件界面中自动弹出报警位置关联的监控摄像头图像，查看报警现场视频图像辅助进行火警确认。</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg1.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt2">视频监控采用专网组网的方式，摄像机、监控客户端以及系统服务器都部署在一个视频专网中。视频监控专网系统负责摄像机的接入管理，视频分发。视频监控客户端可以完成查看摄像机的实时视频，录像回放等视频监控基本功能。</p>
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">智慧消防水监测系统</p>
          <p class="part3_item_txt2">消防水监测系统是集管网实时状态监测、室外水源快速定位、管网状态预警、管网报警查询、管网故障分析功能于一体的消防水应用系统。系统将物联网技术，GIS地图在线展示技术、管网日常监管工作进行结合，能更方便直观对管网进行监管。从根本上解决了消防管网内无水或水压不足、阀门误关闭，设备运行故障、消防用水被盗用等问题，实现了系统动态监测、巡检、消防设备管理一体化。</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg2.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">智慧用电安全系统</p>
          <p class="part3_item_txt2">智慧用电安全系统可以对引起电气火灾的主要因素：线缆温度、剩余电流等进行实时在线监测和统计分析，实时发现电气线路和用电设备存在的安全隐患（如线缆温度异常、过载、漏电等），经云系统大数据分析，即使通过语音电话、短信、APP方式向安全管理人员发送预警信息，指导其开展隐患治理，达到消除潜在的电气火灾危险，实现“防患于未然”的目的。系统能有效解决各用电场所因电气线路老旧、用电行为不规范造成的电气安全隐患问题，确保各用电场所的用电安全。</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg3.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">智能无线烟雾报警器</p>
          <p class="part3_item_txt2">智能无线烟雾报警器，采用高品质元件，结合先进电子技术及精良工艺而制成。一旦烟雾浓度达到报警设定值，探测器将发出声光报警信号，提醒您立即采取措施；或启动联动装置，排除险情，有效避免火灾、爆炸、中毒等恶性事故的发生。采用微处理器控制，高可靠，低误报；现场声，光报警。</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg4.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">智能无线燃气报警器</p>
          <p class="part3_item_txt2">智能无线燃气报警器测量范围为0~100%LEL的独立式可燃气体探测器是用来检测天然气气体泄露的探测器。探测器检测基本原理是随着被检气体的浓度增大，传感器阻值下降，在检测电路中，通过电阻电压转换电路，将传感器电阻值随浓度变化转换成电压随浓度的变化，将该电压与探测器单片机设定的报警动作与设定电压相比较，如超过设定电压则输出声光报警信号报警，需求可输出的控制信号，控制相关执行机构或数据</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg5.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">报警主机检测传感器</p>
          <p class="part3_item_txt2">一款无线wifi通信控制的光耦隔离大电流晶体管IO开关量输入输出控制设备。</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg6.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">手动报警按钮</p>
          <p class="part3_item_txt2">道常见型按钮，按下红色按钮触发报警信号，常开常闭接线可选，广泛用于各类公共安全场所</p>
        </div>
        <div class="part3_img">
          <img src="static/image/ic_part3_bg7.png" alt="">
        </div>
        <div class="part3_item">
          <p class="part3_item_txt1">开关量传感器</p>
          <p class="part3_item_txt2">开关量传感器是一款能够将开关量信号采集输入/控制输出的设备，可将开关量信号采集至物联网管的ai/di接口或者开关量专用接口，主要应用于采集设备运行指示灯状态等信息。主要性能指标如下：</p>
        </div>
        <div class="part3_item">
          <img src="static/image/ic_part3_bg8.png" alt="">
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part1_header">
          <span class="part1_header_txt1">系统优势</span>
          <span class="part1_header_txt2">智能化、精细化、多功能于一体的消防体系</span>
        </div>
        <div class="part5_content_item2">
          <div :class="item.bgColor" v-for="(item,index) in resultList" :key="index+'resultList'">
            <div>
              <img :src="item.normalSrc" alt="">
            </div>
            <span :class="item.txt1Class">{{item.txt1}}</span>
            <span :class="item.txt2Class" v-for="(item1,index1) in item.txt2" :key="index1">{{item1}}</span>
          </div>
        </div>
        <div class="part5_content_item1">
          <div>
            <p class="part5_item1_txt1">01</p>
            <p class="part5_item1_txt2">物联网设备设施的接入、警情联动、报警处置、报警项分发、区域级统计分析。接入：视频监控、报警主机、液位传感器、压力变送器、水浸传感器、温湿度传感器、水泵起停监测等</p>
          </div>
          <div>
            <p class="part5_item1_txt1">02</p>
            <p class="part5_item1_txt2">高效联动，提高物业管理效率；</p>
          </div>
          <div>
            <p class="part5_item1_txt1">03</p>
            <p class="part5_item1_txt2">自动识别人员身份，加强设备巡检管理；</p>
          </div>
          <div>
            <p class="part5_item1_txt1">04</p>
            <p class="part5_item1_txt2">NB-IOT技术，方便施工和维护；</p>
          </div>
          <div>
            <p class="part5_item1_txt1">05</p>
            <p class="part5_item1_txt2">一体化设备设计，安装方便，节省空间；</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">应用场景</span>
          <span class="part1_header_txt2">城中村、智慧园区、古镇景区、政府网格化巡查等</span>
        </div>
        <div class="part7_item">
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg1.png')">
            <p class="part7_item_txt">城中村</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg2.png')">
            <p class="part7_item_txt">智慧园区</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg3.png')">
            <p class="part7_item_txt">古镇景区</p>
          </div>
          <div class="part7_item_box" style="background-image: url('static/image/mf_part7_bg4.png')">
            <p class="part7_item_txt">政府网格化巡查</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">成功案例</span>
          <span class="part1_header_txt2">联合优秀合作伙伴，打造全产业链的消防领军企业</span>
        </div>
        <div class="part7_item">
          <img src="static/image/ic_part8_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part9Box">
      <div class="part9_content">
        <div class="part9_item1">
          <img src="static/image/ic_part9_bg1.png" alt="">
        </div>
        <div class="part9_item2">
          <div class="part9_item2_txt1">
            首钢冬奥园区智慧消防管控云系统
          </div>
          <span class="part9_item2_txt2"></span>
          <div class="part9_item2_txt3">
            首钢冬奥园区划分为冬训、东奥等片区，此次的试点冬训区，包含短道速滑、花样滑冰、冰壶、冰球四个训练场馆和运动员公寓。其中速滑、花滑、冰壶三座训练馆由一座精煤车间改造切割而成，旁边的运煤车站则被改造成冰球馆。
          </div>
          <p class="part9_item2_txt4">
            建设试点：
          </p>
          <p class="part9_item2_txt3">
            消防水泵房、楼顶消防稳压泵房、消防监控室
          </p>
          <p class="part9_item2_txt4">
            设备布置：
          </p>
          <p class="part9_item2_txt3">
            涉及液位传感器、压力变送器、开关量采集器、水浸传感器、温湿度传感器、视频监控、火眼监测、rtu采集器等
          </p>
        </div>
      </div>
    </div>
    <div class="part9Box">
      <div class="part9_content1">
        <div class="part9_item1">
          <img src="static/image/ic_part9_bg2.png" alt="">
        </div>
        <div class="part9_item2">
          <div class="part9_item2_txt1">
            保利香槟国际小区（高层建筑）
          </div>
          <span class="part9_item2_txt2"></span>
          <div class="part9_item2_txt3">
            保利香槟国际小区，位于南京市建邺区金沙江东街，总建筑面积达21万平米，共有21栋18层高层建筑，2012年投入使用，现有住户1379户，沿街商铺53家。
            高层建筑和老旧小区火灾事故频发，人员和财产损失巨大。为了能够长效化、规范化、智慧化地开展此项工作，根据公安部关于全面推进“智慧消防”建设的指导意见，南京市消防支队与南京久润公司合作推出针对高层建筑、老旧小区和九小场所消防安全管理的消管通-智慧消防云系统，并在南京保利小区项目成功试点。
          </div>
          <p class="part9_item2_txt4">
            智慧预警：
          </p>
          <p class="part9_item2_txt3">
            共布置500台独立式烟雾报警器、13台独立式煤气报警器、21台电气火灾报警器、38台消火栓管网压力传感、2台消防水箱液位传感器、1台消防主机火灾报警传输装置。
          </p>
          <p class="part9_item2_txt4">
            智慧管理：
          </p>
          <p class="part9_item2_txt3">
            公设置了304个重点部位、33名物业巡检维保人员、每周产生6333条巡检记录；另外，还在每个单元入口张贴“群众消防隐患随手发”二维码，发动群众举报身边消防隐患。
          </p>
          <p class="part9_item2_txt4">
            大数据墙：
          </p>
          <p class="part9_item2_txt3">
            每天处理1~2条火灾报警或者状态监测报警信号；每周处理2~3条人防上报隐患信息。
          </p>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>

</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "internetControl",
    components: {HeaderCom, FooterCom, RegisterCom},
    data(){
      return{
        resultList:[
          {
            normalSrc:"static/image/ic_part5_bg1.png",
            txt1:"架构",
            txt2:["瞬间获取","系统架构能力"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/ic_part5_bg2.png",
            txt1:"连接",
            txt2:["快速建立","多元数据连接能力"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/ic_part5_bg3.png",
            txt1:"智能",
            txt2:["掌握高难度","ai算法定制能力"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/ic_part5_bg4.png",
            txt1:"上云",
            txt2:["数据快速","上云能力"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/ic_part5_bg5.png",
            txt1:"界面",
            txt2:["快速具备","界面开发能力"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },

        ],
      }
    },
    methods:{
      addActive1(e,index){
        this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+"Active.png";
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive1(e,index){
        this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+".png";
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .ic_btnColor{
    background:rgba(42,98,255,1);
  }
  .part1Box{
    width:100%;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 50px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part1_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 35px 0;
  }
  .part1_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part1_space{
    padding: 0 0 80px 0;
  }
  .part1_item{
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .part1_item img{
    width: 160px;
    height: 160px;
  }
  .part1_itemBox{
    width: 54%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
  }
  .part1_item span{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:24px;
  }
  .part1_itemBox1{
    width: 100%;
    padding: 0;
  }
  .part2Box{
    width:100%;
    height:660px;
    display: flex;
    justify-content: center;
    background:rgba(42,98,255,1);
    background-size: 100% 100%;
  }
  .part2_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:30px;
  }
  .part2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
  }
  .part2_item{
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .part2_itemInfo{
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 30px 0 0 0;
  }
  .part2_itemInfo_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .part2_itemInfo_txt1Ac{
    color: #2A62FF;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3_item{
    width: 100%;
  }
  .part3_item_txt1{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part3_item_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 30px 0;
  }
  .part3_img{
    text-align: center;
  }
  .part5Box{
    width: 100%;
    height: 740px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:rgba(238,242,254,1);
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .part5_content_item{
    width: 1200px;
    border-radius:1px;

  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
    justify-content: space-between;
  }
  .part5_content_item1>div{
    width:220px;
    height:300px;
    background:rgba(255,255,255,1);
    box-sizing: border-box;
    padding: 20px;
  }
  .part5_item1_txt1{
    text-align: center;
    font-size:30px;
    font-family:DIN;
    font-weight:500;
    color:rgba(240,147,51,1);
    line-height:24px;
    box-sizing: border-box;
    padding: 0 0 20px 0;
  }
  .part5_item1_txt2{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:24px;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:220px;
    height:220px;
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    cursor: pointer;
    text-align: center;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part6_content{
    width: 1200px;
  }
  .part6_content_txt{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
    padding: 30px 0;
  }
  .part6_content_img{
    text-align: center;
  }
  .part6_content_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part6_content_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part7Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .part7_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 0 70px 0;
  }
  .part7_item_box{
    width:282px;
    height:180px;
    box-sizing: border-box;
    position: relative;
  }
  .part7_item_txt{
    width:100%;
    height:30px;
    background:rgba(0,0,0,0.5);
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
    text-align: center;position: absolute;
    z-index: 1;
    bottom: 0;
  }
  .part7_item_box1{
    width:380px;
    height:200px;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    padding:30px 30px 0 40px;
  }
  .part7_item_txt1{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part9Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }
  .part9_content{
    width: 1200px;
    height:420px;
    display: flex;
  }
  .part9_content1{
    width: 1200px;
    height:600px;
    display: flex;
  }
  .part9_item1{
    width:450px;
  }
  .part9_item2{
    flex: 1;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;
  }
  .part9_item2_txt1{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part9_item2_txt2{
    display: inline-block;
    width:50px;
    height:2px;
    background:rgba(59,74,117,1);
    border-radius:1px;
    box-sizing: border-box;
    margin: 20px 0 20px 0;
  }
  .part9_item2_txt3{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part9_item2_txt4{
    font-size: 18px;
    font-family: PingFang-SC-Bold;
    font-weight:bold;
    color:#3B4A75;
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/internetControl.vue